import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginSelector } from "../../Login/Reducers/LoginReducer";
export function AdminRoute({ children, ...rest }) {
  const { is_org_admin, authenticated } = useSelector(loginSelector);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authenticated && (is_org_admin || Boolean(sessionStorage.getItem("is_org_admin"))) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
